import React from 'react';
import './Heading.css';

const IconHeading = ({ icon: Icon, title, headingSize }) => {
    return (
        <div className="icon-heading">
            <span className={`icon-size-${headingSize}`}>{Icon && <Icon />}</span>
            <h1 className={`heading-title heading-size-${headingSize}`}>{title}</h1>
        </div>
    );
};

//['small', 'medium', 'large']

export default IconHeading;
